'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useFundingNavigation } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import { type ReactNode, useRef, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { TOAST_IDS } from '@/config/toast-ids';
import { logger } from '@/lib/telemetry/logger';
import { showToast } from '@/lib/ui/toast';
export function FundingReceiptActions(t0) {
  const $ = _c(17);
  const {
    client,
    onRefresh
  } = t0;
  const t = useTranslations("onramp");
  const navigation = useFundingNavigation(client);
  const refreshing = useRef(false);
  const [busy, setBusy] = useState(false);
  let t1;
  if ($[0] !== onRefresh || $[1] !== t) {
    t1 = async function refresh() {
      if (refreshing.current) {
        return;
      }
      refreshing.current = true;
      setBusy(true);
      showToast({
        id: TOAST_IDS.ONRAMP_RECEIPT_REFRESH,
        message: t("receipt_fetching_status"),
        variant: "loading"
      });
      try {
        await onRefresh();
        showToast({
          id: TOAST_IDS.ONRAMP_RECEIPT_REFRESH,
          message: t("receipt_status_updated"),
          variant: "success"
        });
      } catch {
        logger.warn("onramp.receipt_refresh_failed", {
          source: "manual"
        });
        showToast({
          id: TOAST_IDS.ONRAMP_RECEIPT_REFRESH,
          message: t("receipt_status_update_failed"),
          variant: "error"
        });
      }
      refreshing.current = false;
      setBusy(false);
    };
    $[0] = onRefresh;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const refresh = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("receipt_refresh_status");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== busy || $[6] !== refresh || $[7] !== t2) {
    t3 = <AnimatedButton variant="outline" className="h-11 flex-1 rounded-control" loading={busy} disabled={busy} onClick={refresh}>{t2}</AnimatedButton>;
    $[5] = busy;
    $[6] = refresh;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = navigation.openHistory;
  let t5;
  if ($[9] !== t) {
    t5 = t("receipt_view_history");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== navigation.openHistory || $[12] !== t5) {
    t6 = <AnimatedButton className="h-11 flex-1 rounded-control" onClick={t4}>{t5}</AnimatedButton>;
    $[11] = navigation.openHistory;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex flex-col gap-2"><div className="flex gap-2">{t3}{t6}</div></div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}